<template>
  <div class="relative" v-bind="$attrs">
    <div ref="map" class="custom-google-map" :class="mapElementClass"></div>
    <div style="display: none">
      <div ref="popup"></div>
    </div>
    <transition name="fade-in">
      <div
        class="
          absolute
          right-4
          bottom-5
          hidden
          pointer-events-none
          md:grid
          grid-flow-col
          gap-0.5
        "
        v-if="showZoom"
      >
        <button
          class="
            w-8
            aspect-squar
            bg-white
            pointer-events-auto
            border border-lime
            rounded
            text-lime
            grid
            place-items-center
          "
          aria-label="Zoom out"
          @click="zoom(false)"
        >
          -
        </button>
        <button
          class="
            w-8
            aspect-square
            bg-white
            pointer-events-auto
            border border-lime
            rounded
            text-lime
            grid
            place-items-center
          "
          aria-label="Zoom in"
          @click="zoom(true)"
        >
          +
        </button>
      </div>
    </transition>
  </div>
</template>

<script>
import GoogleMap from '../../lib/google-map'
import initSwiper from '../../lib/init-swiper'
import initLazyImage from '../../lib/lazy-image'

export default {
  name: 'MapWithPopup',
  data() {
    return {
      selectedMarker: null,
      googleMap: null,
    }
  },
  mounted() {
    this.googleMap = new GoogleMap(this.$refs.map, {
      markersDir: this.markersDir,
      onMarkerClick: (markerData) => {
        this.selectedMarker = markerData
      },
      infowindowContent: this.$refs.popup,
      useCircles: false,
      mapOptions: this.mapOptions,
      noClusterer: this.noClusterer,
      swissCoordinates: this.swissCoordinates,
      onBoundsChange: (bounds) => this.$emit('boundschange', bounds),
      initialBounds: this.initialBounds,
      spiderify: this.spiderify,
    })
    this.googleMap.setMarkers(this.markers)
    if (!this.disableAutoFit) {
      this.googleMap.fitToMarkers()
    }
  },
  props: {
    markers: Array,
    mapElementClass: String,
    markersDir: String,
    cardComponent: String,
    showZoom: Boolean,
    mapOptions: Object,
    noClusterer: Boolean,
    swissCoordinates: Boolean,
    initialBounds: {
      type: Object,
      default: null,
    },
    disableAutoFit: {
      type: Boolean,
      default: false,
    },
    spiderify: Boolean,
  },
  watch: {
    markers(newMarkers) {
      this.googleMap.setMarkers(newMarkers)
      if (!this.disableAutoFit) {
        this.googleMap.fitToMarkers()
      }
    },
    selectedMarker(marker) {
      if (!marker) return

      const templateCard = document.getElementById('template-card')
      const templateImage = document.getElementById('template-card__image')
      const templateTag = document.getElementById('template-card__tag')
      const cardHtml = templateCard ? templateCard.innerHTML : ''
      const imageHtml = templateImage ? templateImage.innerHTML : ''
      const tagHtml = templateTag ? templateTag.innerHTML : ''

      let resultHtml = cardHtml
      resultHtml = resultHtml.replace('{{href}}', marker.href)
      resultHtml = resultHtml.replace('{{title}}', marker.title)
      resultHtml = resultHtml.replace('{{price}}', marker.price)
      resultHtml = resultHtml.replace('{{location}}', marker.location)
    
      this.$refs.popup.innerHTML = resultHtml

      const tags = this.$refs.popup.querySelector('.js-property-tags')
      if (tags) {
        let tagsHtml = ''
        for (const tag of marker.tags) {
          tagsHtml += tagHtml.replace('{{text}}', tag)
        }
        tags.innerHTML = tagsHtml
      }
      
      const swiperWrapper = this.$refs.popup.querySelector('.swiper-wrapper')
      let slidesHtml = ''
      for (const src of marker.images) {
        slidesHtml += imageHtml.replace('{{src}}', src)
      }
      swiperWrapper.innerHTML = slidesHtml

      initLazyImage(this.$refs.popup)
      initSwiper(this.$refs.popup)
      
      setTimeout(() => {
        window.dispatchEvent(new Event('resize'))
      }, 0)
    },
  },
  methods: {
    zoom(increase) {
      const zoom = this.googleMap.map.getZoom()
      this.googleMap.map.setZoom(increase ? zoom + 1 : zoom - 1)
    },
  }
}
</script>